module.exports = __webpack_public_path__ + "img/lunch bag.ee3d8cf4.svg";